import {StatisticsWidget5} from '../../../_metronic/partials/widgets'
import {useDashboard} from '../../../hooks/kpi/useDashboard'

export function SalesByFilteredDate() {
  const {query} = useDashboard()
  const salesByFilteredDate = query.data?.salesByFilteredDate ?? '0'
  const isLoading = query.isLoading

  return (
    <>
      {isLoading && (
        <div className={`card card-flush`} style={{minHeight: '150px'}}>
          <div className='card-body pt-1 pb-4 d-flex flex-wrap flex-center p-4 px-10'>
            <div className='d-flex flex-center w-100'>
              <div className='text-center w-100 align-items-center justify-content-center'>
                <span>Carregando...</span>
              </div>
            </div>
          </div>
        </div>
      )}
      {!isLoading && (
        <div className='col-12'>
          <div className='space-dash-graph-height w-100 hover-danger-text'>
            <div className='d-flex flex-center w-100'>
              <StatisticsWidget5
                className='card-xl-stretch mb-xl-8 w-100'
                svgIcon='chart-simple'
                color='white'
                iconColor='danger'
                title={salesByFilteredDate}
                description='Vendas geradas'
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
